<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @beforeEnter="beforeEnter"
    @afterEnter="afterEnter"
    @beforeLeave="beforeLeave"
    @afterLeave="afterLeave">
    <div :class="classes" v-if="show" v-show="showModalOnInit || imageLoadComplete || forceShowModal">
      <div class="modal-background" @click="deactive"></div>
      <div class="modal-container">
        <div class="modal-content">
          <div class="fct-box box-container">
            <button class="fct-modal-close fct-admin-icon-times" @click="afterLeave" v-if="closable && !closeButtonHidden"></button>
            <v-bar class="scroll-area" :settings="{suppressScrollX: true, useBothWheelAxes: true}">
              <div class="b-slot">
                <slot :onImageLoad="onImageLoad"></slot>
              </div>
            </v-bar>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import BaseModal from './BaseModal';
  import ImageHandler from '../../mixins/imageHandler';

  export default {
    mixins: [BaseModal, ImageHandler],
    data() {
      return {
        forceShowModal: false
      };
    },
    props: {
      closable: {
        type: Boolean,
        default: true
      },
      closeButtonHidden: {
        type: Boolean,
        default: false
      },
      showModalOnInit: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      test() {
        return 'test';
      }
    },

    computed: {
      classes() {
        return ['modal', 'animated', 'is-active'];
      }
    },
    mounted() {
      setTimeout(() => {
        this.forceShowModal = true;
      }, 2000);
    }
  };
</script>
<style lang="scss">
  @import "../../../node_modules/bulma/sass/utilities/mixins";
  @import "../../../sass/fct/variables";
  @import "../../../sass/fct/fct-box/mixins/box";

  .modal {
    z-index: 10000;
    .fct-box {
      padding-bottom: 40px;
      max-height: 100vh !important;
    }

    @include mobile() {
      .fct-box {
        margin: auto;
        @include box;
      }
    }

    .modal-background {
      background: #000628;
      opacity: 0.5;

      @include tablet() {
        margin: 0 -30px;
      }
    }

    .modal-content, .modal-card {
      overflow: visible;
      width: 100vw;
    }

    .no-text {
      h3 {
        margin: 32px 0;
      }
    }

    h3 {
      margin-top: 10px;
      font-size: 20px;
      padding-bottom: 10px;
      font-family: 'montserratextrabold';
      color: $black;
    }

    p {
      color: $light-grey;
      font-size: 15px;

      font-family: montserratmedium;
      margin-bottom: 15px;
    }

    @include mobile() {
      p {
        font-size: 14px
      }

      h1 {
        font-size: 18px;
      }
    }


    @include tablet() {
      overflow: visible;

      .modal-container {
        width: 550px;

        .notification-box {
          position: absolute;
          bottom: 20px;
          left: 20px;
          right: 20px;

          h3 {
            font-size: 24px;
            text-align: center;
            margin-top: 20px;
          }

          p {
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
  }

  .modal-content {
    padding-top: 60px;
    padding-bottom: 45px;

    .fct-box {
      width: auto;
      padding: 0 !important;
      margin: 0 !important;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 520px;
      min-height: 550px;

      &.box-container {
        .scroll-area {
          max-height: calc(100vh - 60px);
          position: relative;
          margin-right: -15px;
          padding-right: 15px;

          .ps .ps__scrollbar-x-rail {
            display: none !important;
          }

          .ps__scrollbar-y-rail {
            transform: translateX(-15px);
          }


          //temp
          .ps__scrollbar-x-rail {
            display: none !important;

            > .ps__scrollbar-x {
              display: none !important;
            }
          }

          .b-slot {
            padding: 30px;
            max-height: 100vh;
            border: none;
          }
        }
      }

      @include mobile() {
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 40px);
        min-height: 480px;
      }

      overflow: visible;

      text-align: center;

      .fct-button {
        font-weight: 700;
        margin: 15px 0 0 0;
        @include tablet() {
          min-width: 110px !important;
        }

        @include mobile() {
          width: 100%;
        }
      }

      .fct-modal-close {
        z-index: 1000;
        position: absolute;
        top: 15px;
        right: 15px;
        padding: 3px;

        &:hover {
          cursor: pointer;
        }

        outline: none !important;

        background-color: transparent;
        border: none;
      }
    }
  }

  .modal-content, .model-card {
    max-height: 100vh !important;
    @include mobile() {
      padding: 40px !important;
    }
  }
</style>
